import React from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';

import { Spinner } from '../../../../../components';
import { DocumentSignedURL } from '../../../../../types/main';
import MediaPreviewStyles from './styles';

type Props = {
  signedUrl: DocumentSignedURL | undefined;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const MediaImage = ({
  signedUrl, swipeable, slideDirection, isChangePreviewMedia,
}: Props) => {
  const classes = MediaPreviewStyles();

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      {
        signedUrl === undefined
          ? (
            <div {...swipeable} className={classes.wrapper}>
              <Spinner />
            </div>
          )
          : (
            <div {...swipeable} className={classes.wrapper}>
              <img src={signedUrl.url} alt="" className={classes.image} />
            </div>
          )
      }
    </Slide>
  );
};

export default MediaImage;
